import { render, staticRenderFns } from "./SocialCharges.vue?vue&type=template&id=5bcf56b2&scoped=true"
import script from "./SocialCharges.vue?vue&type=script&lang=js"
export * from "./SocialCharges.vue?vue&type=script&lang=js"
import style0 from "./SocialCharges.vue?vue&type=style&index=0&id=5bcf56b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf56b2",
  null
  
)

export default component.exports